/**
 * Do not edit directly, this file was auto-generated.
 */

export const charcoalText = "rgb(255, 255, 255)";
export const charcoalTintText = "rgb(35, 33, 33)";
export const charcoalMidText = "rgb(255, 255, 255)";
export const charcoalShadeText = "rgb(255, 255, 255)";
export const charcoal50Text = "rgb(35, 33, 33)";
export const charcoal100Text = "rgb(35, 33, 33)";
export const charcoal200Text = "rgb(35, 33, 33)";
export const charcoal300Text = "rgb(255, 255, 255)";
export const charcoal400Text = "rgb(255, 255, 255)";
export const charcoal500Text = "rgb(255, 255, 255)";
export const charcoal600Text = "rgb(255, 255, 255)";
export const charcoal700Text = "rgb(255, 255, 255)";
export const charcoal800Text = "rgb(255, 255, 255)";
export const charcoal900Text = "rgb(255, 255, 255)";
export const coolGrayText = "rgb(35, 33, 33)";
export const coolGray50Text = "rgb(35, 33, 33)";
export const coolGray100Text = "rgb(35, 33, 33)";
export const coolGray200Text = "rgb(35, 33, 33)";
export const coolGray300Text = "rgb(35, 33, 33)";
export const coolGray400Text = "rgb(35, 33, 33)";
export const coolGray500Text = "rgb(35, 33, 33)";
export const coolGray600Text = "rgb(35, 33, 33)";
export const coolGray700Text = "rgb(35, 33, 33)";
export const coolGray800Text = "rgb(255, 255, 255)";
export const coolGray900Text = "rgb(255, 255, 255)";
export const cottonText = "rgb(35, 33, 33)";
export const cottonTintText = "rgb(35, 33, 33)";
export const cottonMidText = "rgb(35, 33, 33)";
export const cottonShadeText = "rgb(35, 33, 33)";
export const cotton50Text = "rgb(35, 33, 33)";
export const cotton100Text = "rgb(35, 33, 33)";
export const cotton200Text = "rgb(35, 33, 33)";
export const cotton300Text = "rgb(35, 33, 33)";
export const cotton400Text = "rgb(35, 33, 33)";
export const cotton500Text = "rgb(35, 33, 33)";
export const cotton600Text = "rgb(35, 33, 33)";
export const cotton700Text = "rgb(35, 33, 33)";
export const cotton800Text = "rgb(35, 33, 33)";
export const cotton900Text = "rgb(35, 33, 33)";
export const eggplantText = "rgb(255, 255, 255)";
export const eggplantTintText = "rgb(35, 33, 33)";
export const eggplantMidText = "rgb(35, 33, 33)";
export const eggplantShadeText = "rgb(255, 255, 255)";
export const eggplant50Text = "rgb(35, 33, 33)";
export const eggplant100Text = "rgb(35, 33, 33)";
export const eggplant200Text = "rgb(35, 33, 33)";
export const eggplant300Text = "rgb(35, 33, 33)";
export const eggplant400Text = "rgb(255, 255, 255)";
export const eggplant500Text = "rgb(255, 255, 255)";
export const eggplant600Text = "rgb(255, 255, 255)";
export const eggplant700Text = "rgb(255, 255, 255)";
export const eggplant800Text = "rgb(255, 255, 255)";
export const eggplant900Text = "rgb(255, 255, 255)";
export const orangeText = "rgb(35, 33, 33)";
export const orangeTintText = "rgb(35, 33, 33)";
export const orangeMidText = "rgb(35, 33, 33)";
export const orangeShadeText = "rgb(35, 33, 33)";
export const orange50Text = "rgb(35, 33, 33)";
export const orange100Text = "rgb(35, 33, 33)";
export const orange200Text = "rgb(35, 33, 33)";
export const orange300Text = "rgb(35, 33, 33)";
export const orange400Text = "rgb(35, 33, 33)";
export const orange500Text = "rgb(35, 33, 33)";
export const orange600Text = "rgb(35, 33, 33)";
export const orange700Text = "rgb(35, 33, 33)";
export const orange800Text = "rgb(255, 255, 255)";
export const orange900Text = "rgb(255, 255, 255)";
export const pinkText = "rgb(35, 33, 33)";
export const pinkTintText = "rgb(35, 33, 33)";
export const pinkMidText = "rgb(35, 33, 33)";
export const pinkShadeText = "rgb(35, 33, 33)";
export const pink50Text = "rgb(35, 33, 33)";
export const pink100Text = "rgb(35, 33, 33)";
export const pink200Text = "rgb(35, 33, 33)";
export const pink300Text = "rgb(35, 33, 33)";
export const pink400Text = "rgb(35, 33, 33)";
export const pink500Text = "rgb(35, 33, 33)";
export const pink600Text = "rgb(35, 33, 33)";
export const pink700Text = "rgb(35, 33, 33)";
export const pink800Text = "rgb(255, 255, 255)";
export const pink900Text = "rgb(255, 255, 255)";
export const poppyText = "rgb(35, 33, 33)";
export const poppyTintText = "rgb(35, 33, 33)";
export const poppyMidText = "rgb(35, 33, 33)";
export const poppyShadeText = "rgb(255, 255, 255)";
export const poppy50Text = "rgb(35, 33, 33)";
export const poppy100Text = "rgb(35, 33, 33)";
export const poppy200Text = "rgb(35, 33, 33)";
export const poppy300Text = "rgb(35, 33, 33)";
export const poppy400Text = "rgb(35, 33, 33)";
export const poppy500Text = "rgb(35, 33, 33)";
export const poppy600Text = "rgb(35, 33, 33)";
export const poppy700Text = "rgb(255, 255, 255)";
export const poppy800Text = "rgb(255, 255, 255)";
export const poppy900Text = "rgb(255, 255, 255)";
export const skyText = "rgb(35, 33, 33)";
export const skyTintText = "rgb(35, 33, 33)";
export const skyMidText = "rgb(35, 33, 33)";
export const skyShadeText = "rgb(35, 33, 33)";
export const sky50Text = "rgb(35, 33, 33)";
export const sky100Text = "rgb(35, 33, 33)";
export const sky200Text = "rgb(35, 33, 33)";
export const sky300Text = "rgb(35, 33, 33)";
export const sky400Text = "rgb(35, 33, 33)";
export const sky500Text = "rgb(35, 33, 33)";
export const sky600Text = "rgb(35, 33, 33)";
export const sky700Text = "rgb(35, 33, 33)";
export const sky800Text = "rgb(255, 255, 255)";
export const sky900Text = "rgb(255, 255, 255)";
export const stoneText = "rgb(35, 33, 33)";
export const stoneTintText = "rgb(35, 33, 33)";
export const stoneMidText = "rgb(35, 33, 33)";
export const stoneShadeText = "rgb(35, 33, 33)";
export const stone50Text = "rgb(35, 33, 33)";
export const stone100Text = "rgb(35, 33, 33)";
export const stone200Text = "rgb(35, 33, 33)";
export const stone300Text = "rgb(35, 33, 33)";
export const stone400Text = "rgb(35, 33, 33)";
export const stone500Text = "rgb(35, 33, 33)";
export const stone600Text = "rgb(35, 33, 33)";
export const stone700Text = "rgb(35, 33, 33)";
export const stone800Text = "rgb(255, 255, 255)";
export const stone900Text = "rgb(255, 255, 255)";
export const violetText = "rgb(35, 33, 33)";
export const violetTintText = "rgb(35, 33, 33)";
export const violetMidText = "rgb(35, 33, 33)";
export const violetShadeText = "rgb(255, 255, 255)";
export const violet50Text = "rgb(35, 33, 33)";
export const violet100Text = "rgb(35, 33, 33)";
export const violet200Text = "rgb(35, 33, 33)";
export const violet300Text = "rgb(35, 33, 33)";
export const violet400Text = "rgb(35, 33, 33)";
export const violet500Text = "rgb(35, 33, 33)";
export const violet600Text = "rgb(255, 255, 255)";
export const violet700Text = "rgb(255, 255, 255)";
export const violet800Text = "rgb(255, 255, 255)";
export const violet900Text = "rgb(255, 255, 255)";
export const yellowText = "rgb(35, 33, 33)";
export const yellowTintText = "rgb(35, 33, 33)";
export const yellowMidText = "rgb(35, 33, 33)";
export const yellowShadeText = "rgb(35, 33, 33)";
export const yellow50Text = "rgb(35, 33, 33)";
export const yellow100Text = "rgb(35, 33, 33)";
export const yellow200Text = "rgb(35, 33, 33)";
export const yellow300Text = "rgb(35, 33, 33)";
export const yellow400Text = "rgb(35, 33, 33)";
export const yellow500Text = "rgb(35, 33, 33)";
export const yellow600Text = "rgb(35, 33, 33)";
export const yellow700Text = "rgb(35, 33, 33)";
export const yellow800Text = "rgb(35, 33, 33)";
export const yellow900Text = "rgb(255, 255, 255)";
export const whiteText = "rgb(35, 33, 33)";
export const lightSandText = "rgb(35, 33, 33)";
export const lemonText = "rgb(35, 33, 33)";
export const cedarText = "rgb(255, 255, 255)";
export const cedarShadeText = "rgb(255, 255, 255)";
export const cedarTintText = "rgb(35, 33, 33)";
export const charcoal85Text = "rgb(255, 255, 255)";
export const charcoalMidTintText = "rgb(255, 255, 255)";
export const lakeText = "rgb(35, 33, 33)";
export const lakePopText = "rgb(35, 33, 33)";
export const lakeShadeText = "rgb(35, 33, 33)";
export const lakeTintText = "rgb(35, 33, 33)";
export const lavenderText = "rgb(35, 33, 33)";
export const lavenderLightText = "rgb(35, 33, 33)";
export const lavenderMidTintText = "rgb(35, 33, 33)";
export const lavenderShadeText = "rgb(255, 255, 255)";
export const lavenderTintText = "rgb(35, 33, 33)";
export const sandShadeText = "rgb(35, 33, 33)";
export const sandTintText = "rgb(35, 33, 33)";
export const sandText = "rgb(35, 33, 33)";
export const poppy06Text = "rgb(255, 255, 255)";
